<template>
  <div class="vcita-divider"
       :style="`--text-divider-color: ${color}`" >

    <div v-if="text"
         data-testid="vcita-text-divider"
         class="text-divider" >
      {{ text }}
    </div>

    <v-divider v-else
               data-testid="vcita-divider"
               class="no-text-divider"
               :color="color"/>

  </div>

</template>


<script>

export default {
  name: 'VcitaDivider',
  props:{
    text: {
      type: String,
      required: false
    },
    color: {
      text: {
        type: String,
        required: false
      },
    }
  },
}
</script>

<style lang="scss">

.vcita-divider {
  --text-divider-color: silver;

  .text-divider {
    display: flex;
    align-items: center;
    font-family: var(--primary-font-family);
    font-size: 10px;
    font-weight: bold;
    text-transform: uppercase;
    color: var(--text-divider-color);
    letter-spacing: 0.03em;
    --text-divider-gap: 8px;

    &::before, &::after {
      content: '';
      height: 1px;
      background-color: var(--text-divider-color);
      flex-grow: 1;
    }

    &::before {
      margin-inline-end: var(--text-divider-gap);
    }

    &::after {
      margin-inline-start: var(--text-divider-gap);
    }
  }
  .no-text-divider {
    color: var(--text-divider-color);
  }
}
</style>
